import * as React from 'react';
import StlViewerPageView from '../layouts/StlViewerPageView';

export interface StlViewerPageprops {
  signedUrlStl: Array<string>;
}

class StlViewerPage extends React.Component<StlViewerPageprops> {
  render() {
    return (
      <div>
        <StlViewerPageView
          signedUrlStl={this.props.signedUrlStl}
        />
      </div>
    );
  }
  // componentDidMount() {
  //   this.props.onComponentDidMount();
  // }
}

export default StlViewerPage;



// WEBPACK FOOTER //
// ./src/components/stlViewer/StlViewerPage.tsx